import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCYzjkmAA7Z3hzlVOKaKJtnCFFAcs59dsA",
  authDomain: "mg-media-news-1dc24.firebaseapp.com",
  projectId: "mg-media-news-1dc24",
  storageBucket: "mg-media-news-1dc24.appspot.com",
  messagingSenderId: "630319903307",
  appId: "1:630319903307:web:e119bbd4f0427ca47c53ce",
  measurementId: "G-E7R3G2BP4D",
};

// Initialize Firebase & Storage
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export default app;
